import { Box, Button, Modal, Typography } from "@mui/material";
import React from "react";

function WarningModal({
    open,
    onClose,
    message = null,
    disableEscapeKeyDown = true
}) {
    return (
        <Modal
            open={open}
            onClose={onClose}
            disableEscapeKeyDown={disableEscapeKeyDown}
        >
            <Box className="box-modal box-modal-xs p-5">
                <div className="pb-3 justify-content-center text-center">
                    <div className="pb-3">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="60"
                            height="60"
                            fill="currentColor"
                            className="bi bi-exclamation-triangle icon-warning"
                            viewBox="0 0 16 16"
                        >
                            <path d="M7.938 2.016A.13.13 0 0 1 8 2c.03 0 .058.01.062.016l6.857 11.856c.054.096.006.128-.054.128H1.135c-.06 0-.108-.032-.054-.128zM8 4.5c-.535 0-.954.462-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4.5m.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2" />
                        </svg>
                    </div>

                    <div className="error-message">
                        <Typography variant="h6">
                            {message}
                        </Typography>
                    </div>
                </div>

                <div className="justify-content-center d-flex">
                    <Button
                        className="w-100"
                        color="warning"
                        variant="outlined"
                        onClick={onClose}
                    >
                        <Typography className="fw-bold" variant="h6">
                            Aceptar
                        </Typography>
                    </Button>
                </div>
            </Box>
        </Modal>
    );
}

export default WarningModal;